export enum WizardActionType {
	REDIRECT = 'redirect',
}
